import { ElementBreadCrumb } from '../../../shared/Components/ElementBreadCrumb';
import { LanguageTranslate } from '../../../shared/Infraestructure/LanguageTranslate';
import './Style.scss';

import foto from '../../../../assets/img/user.png';
import { EntityDataUsuario } from '../../../shared/Domain/EntityDataUsuario';
import esFlag from '../../../../assets/img/es.png';
import usFlag from '../../../../assets/img/us.png';
import deFlag from '../../../../assets/img/de.png';
import itFlag from '../../../../assets/img/it.png';
import { CardComponent } from './Card';
import { FormikProps } from 'formik';
import { IFormNotification } from '../Domain/Form/IFormNotification';

interface PropsViewMain {
    auth: boolean;
    user: EntityDataUsuario;

    showLanguage: boolean;
    setShowLanguage: Function;
    language?: string;
    onChangeLanguage?: Function;

    showChangePassword: boolean;
    setShowChangePassword: Function;
    formChangePassword: { values: any; touched: any; errors: any; handleBlur: Function; };
    onChangePassword: Function;
    onSubmitChangePassword: Function;

    formNotification: FormikProps<IFormNotification>;
    onChangeFormNotification: (name: keyof IFormNotification, value: any) => void;
    onSubmitFormNotification: () => Promise<void>;
};

// const animatedComponents = makeAnimated();
export const ViewMain = (props: PropsViewMain) => {
    const languageTranslate = LanguageTranslate();

    const flags = {
        es: esFlag,
        en: usFlag,
        de: deFlag,
        it: itFlag
    };

    return (
        <div className='ViewProfile'>
            <div className="container-fluid">
                {/** BLOQUE DE BREADCRUMB */}
                <ElementBreadCrumb list={[{ text: languageTranslate.textoConfiguracion, navigate: false, path: '' }]} />
                <div className="row">
                    <div className="col-4 text-center">
                        <img src={foto} className="img-thumbnail" alt="Profile" style={{ borderRadius: '50%' }} width={90} />
                    </div>
                    <div className="col-8">
                        <p style={{ marginBottom: '0.2rem' }}>
                            <span style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>{`${props.user.Name} ${props.user.LastNameFather} ${props.user.LastNameMother}`.trim()}</span>
                        </p>
                        {/* <p style={{ marginBottom: '0.2rem' }}>
                            <span style={{ fontSize: '11px' }}>{`${props.user.Empresa?.Nombre || props.user.Empresa['Empresa' as keyof typeof props.user.Empresa] || ''} - ${props.user.PaisBase.Pais}`}</span>
                        </p> */}
                        <p style={{ marginBottom: '0.2rem' }}>
                            <span style={{ fontSize: '0.65rem' }}>{`${props.user.DatosTrabajo.Area} - ${props.user.DatosTrabajo.Cargo}`}</span>
                        </p>
                    </div>
                </div>
                <div hidden={props.user.IdUser === 0}>
                    <div className="row">

                        {
                            props.user.IdUser !== 0 &&
                            <CardComponent
                                title={languageTranslate.moduloNotificacion.form.title}
                                content={
                                    <div className="card-body">
                                        <div className="row pt-2">
                                            <div className="form-group d-flex">
                                                <label className="mb-1">{languageTranslate.moduloNotificacion.form.notificacion} <span className="text-danger">*</span></label>
                                                <div className="form-check form-switch" style={{ marginLeft: 'auto' }}>
                                                    <input
                                                        checked={props.formNotification.values.active}
                                                        onChange={(evt) => props.onChangeFormNotification('active', evt.target.checked)}
                                                        className="form-check-input"
                                                        type="checkbox"
                                                    />
                                                </div>
                                            </div>

                                            <div className='mt-4 mb-4'>
                                                <label style={{ fontSize: 14, marginBottom: 12 }}>
                                                    <input type="checkbox" disabled={!props.formNotification.values.active} onChange={() => props.onChangeFormNotification('metodoNotification', 1)} checked={props.formNotification.values.metodoNotification.includes(1)} />&nbsp;&nbsp; {languageTranslate.moduloNotificacion.form.opcionAprobacion}
                                                </label>

                                                <label style={{ fontSize: 14, marginBottom: 20 }}>
                                                    <input type="checkbox" disabled={!props.formNotification.values.active} onChange={() => props.onChangeFormNotification('metodoNotification', 2)} checked={props.formNotification.values.metodoNotification.includes(2)} />&nbsp;&nbsp; {languageTranslate.moduloNotificacion.form.opcionGrupal}
                                                </label>
                                            </div>
 
                                            <button className='btn btn-primary w-100' onClick={() => props.onSubmitFormNotification()}>{languageTranslate.btnGuardar}</button>
                                        </div>
                                    </div>
                                }
                            />
                        }

                        <CardComponent
                            title={languageTranslate.moduloConfiguracion.textoIdioma}
                            content={
                                <div className="card-body">
                                    <div className="row pt-2">
                                        {
                                            languageTranslate.languages.map(row => (
                                                <div className="col-4" key={row.code}>
                                                    <input
                                                        type="radio"
                                                        className="btn-check"
                                                        name="options-outlined"
                                                        id={`inputIdioma${row.code}`}
                                                        value={row.code}
                                                        onChange={(evt) => evt.target.checked ? !!props.onChangeLanguage ? props.onChangeLanguage(row.code) : undefined : undefined}
                                                        checked={props.language === row.code ? true : false}
                                                    />
                                                    <label className="btn btn-sm btn-outline-primary" htmlFor={`inputIdioma${row.code}`}>
                                                        <img src={flags[row.code as keyof typeof flags]} alt="flag" /> {row.name}
                                                    </label>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            }
                        />

                        <CardComponent
                            title={languageTranslate.moduloConfiguracion.textoCambioPassword}
                            content={
                                <div className="card-body">
                                    <form className="row" noValidate onSubmit={(e) => props.onSubmitChangePassword(e)}>
                                        <div className="col-12 pt-2 mb-2">
                                            <p className='mb-1' style={{ fontSize: 14 }}> {languageTranslate.moduloConfiguracion.textoNuevaPassword} <span className='text-danger'>*</span></p>
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text" >
                                                    <i className="fa-solid fa-key" />
                                                </span>
                                                <input
                                                    type="password"
                                                    name="newPassword"
                                                    className="form-control"
                                                    required
                                                    placeholder={languageTranslate.moduloConfiguracion.textoNuevaPassword}
                                                    value={props.formChangePassword.values['newPassword']}
                                                    onChange={(evt) => { props.onChangePassword('newPassword', evt.target.value) }}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 pt-2 mb-2">
                                            <p className='mb-1' style={{ fontSize: 14 }}> {languageTranslate.moduloConfiguracion.textoRepetirNuevaPassword} <span className='text-danger'>*</span></p>
                                            <div className="input-group input-group-sm">
                                                <span className="input-group-text" >
                                                    <i className="fa-solid fa-key" />
                                                </span>
                                                <input
                                                    type="password"
                                                    name="reNewPassword"
                                                    className="form-control"
                                                    required
                                                    placeholder={languageTranslate.moduloConfiguracion.textoRepetirNuevaPassword}
                                                    value={props.formChangePassword.values['reNewPassword']}
                                                    onChange={(evt) => { props.onChangePassword('reNewPassword', evt.target.value) }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 pt-2">
                                            <button type="submit" className="btn btn-primary" style={{ width: '100%', backgroundColor: '#01397D' }}>
                                                {languageTranslate.moduloConfiguracion.textoBotonSaveCambioPassword}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            }
                        />
                    </div>
                </div>

            </div>
        </div >
    )
};